<template>
  <div>
  <div v-permission="['view_wallet']" class="cornerfilter">
  <router-link :to="{ name: 'Wallet'}">
  Wallet
  </router-link>
</div>
  <div class="card-header">
    <div class="card-header-col card-col w30">
      <Checkbox v-if="disableSelectAll" disabled v-model="checkAll"/>
      <Checkbox v-else @change="$emit('selectAll', checkAll)"  v-model="checkAll"/>
    </div>
    <div :class="column.class"
       v-for="column in headers" :key="column.id">{{column.label}}</div>
    <div class="card-header-col card-col w30">
    </div>
  </div>
</div>
</template>

<script>
export default {
  props: {
    disableSelectAll: {
      type: Boolean,
      default: false,
    },
    columns: Array,
  },
  data() {
    return {
      checkAll: false,
    };
  },
  computed: {
    headers() {
      return this.columns.map(column =>
        Object.assign({}, column, {
          class: `card-header-col card-col ${column.class}`,
        }),
      );
    },
  },
};
</script>

<style lang="scss">
@import "~@common/styles-shipper/settings";
.cornerfilter {
  text-align: right;
  margin-bottom: 20px;
  z-index: 9;
  position: relative;
  a {
    color: #234357;
    font-size: 1.2rem;
    font-family:$fontSemibold;
  }
}
</style>
